import ReactComponent from "./application"

import HelloReact from "./components/HelloReact";
import AbstractBulkLoadEntityForm from "./components/abstract/bulk/load/entity/form";
import AbstractBulkLoadDocumentForm from "./components/abstract/bulk/load/document/form";
import AbstractBulkRequestDocumentForm from "./components/abstract/bulk/request/document/form";
import AbstractCheckListProcessForm from "./components/abstract/check_list/process/form";
import LaboralBulkLoadHiringDocumentForm from "./components/laboral/bulk/load/hiring_document/form";
import LaboralBulkLoadEmployeeForm from "./components/laboral/bulk/load/employee/form";
import LaboralBulkLoadHiringForm from "./components/laboral/bulk/load/hiring/form";
import LaboralBulkRequestHiringDocumentForm from "./components/laboral/bulk/request/hiring_document/form";
import CorporateBulkRequestAgreementDocumentForm from "./components/corporate/bulk/request/agreement_document/form";
import LaboralBulkNotificationSignForm from "./components/laboral/bulk/notification/sign/form";
import CorporateBulkNotificationSignForm from "./components/corporate/bulk/notification/sign/form";
// import DocumentForm from "./components/document/form";
// import ControldocFormTemplateForm from "./components/controldoc_form/template/form";
import ControldocFormTemplateMappingLinkForm from "./components/controldoc_form/template_mapping_link/form";
import DocumentTypeForm from "./components/document_type/form";
import LaboralBulkRequestZipDocumentForm from "./components/laboral/bulk/request/zip/document/form";
import LaboralCheckListHiringProcessForm from './components/laboral/check_list/hiring_process/form';
import CorporateCheckListAgreementProcessForm from './components/corporate/check_list/agreement_process/form';
import LaboralBulkRequestDestroyEmployeeForm from "./components/laboral/bulk/request/destroy_employee/form";
import LaboralBulkRequestDestroyDocumentForm from "./components/laboral/bulk/request/destroy_document/form";
//
// Laboral
import LaboralHiringDocumentForm from './components/laboral/hiring_document/form';
import LaboralEmployeeDocumentForm from './components/laboral/employee_document/form';
import LaboralControldocFormTemplateForm from "./components/laboral/controldoc_form/template/form";
import LaboralDocumentTypeForm from "./components/laboral/document_type/form";
import LaboralControldocFormTemplateLayoutForm from "./components/laboral/controldoc_form/template_layout/form";
import LaboralCheckListSharedProcessForm from "./components/laboral/check_list/shared_process/form"
import LaboralCustomFieldOrderFormList from "./components/laboral/custom_field/order_form_list";
import LaboralShortlistMappingConfigForm from './components/laboral/shortlist/mapping_config/form';
import LaboralBulkNotificationFillForm from "./components/laboral/bulk/notification/fill/form";
//
// Laboral Workflow
import LaboralWorkflowBasicForm from "./components/laboral/workflow/process/basic_form.jsx";
import LaboralWorkflowRequirementCommentBox from "./components/laboral/workflow/requirement/comment/box.jsx";
//
//
// Corporate
import CorporateAgreementDocumentForm from './components/corporate/agreement_document/form'
import CorporateControldocFormTemplateForm from "./components/corporate/controldoc_form/template/form";
import CorporateControldocFormTemplateLayoutForm from "./components/corporate/controldoc_form/template_layout/form";
import CorporateDocumentTypeForm from "./components/corporate/document_type/form";
import CorporateCheckListSharedProcessForm from "./components/corporate/check_list/shared_process/form"
import CorporateBulkRequestZipDocumentForm from "./components/corporate/bulk/request/zip/document/form";
//
// Abstract
import AbstractControldocFormTemplateForm from "./components/abstract/controldoc_form/template/form";
import AbstractFaoMappingConfigForm from './components/abstract/fao/mapping_config/form';
import AbstractDocumentForm from './components/abstract/document/form';
import AbstractDocumentTypeForm from "./components/abstract/document_type/form";
import AbstractControldocFormTemplateLayoutForm from "./components/abstract/controldoc_form/template_layout/form";
import AbstractCheckListSharedProcessForm from "./components/abstract/check_list/shared_process/form"
import AbstractBulkRequestZipDocumentForm from "./components/abstract/bulk/request/zip/document/form"
import AbstractEntityForm from "./components/abstract/entity/form";
import AbstractCustomFieldOrderFormList from "./components/abstract/custom_field/order_form_list";
import AbstractEntityFolderCheckListForm from './components/abstract/entity_folder/check_list/form'
import AbstractEntityFolderCheckListSharedForm from './components/abstract/entity_folder/check_list_shared/form'
import AbstractEntityFolderCheckListRequirementForm from './components/abstract/entity_folder/check_list_requirement/form'

import AbstractWorkflowBasicForm from './components/abstract/workflow/process/basic_form';
import AbstractWorkflowRequirementCommentBox from './components/abstract/workflow/requirement/comment/box';
import AbstractWorkflowRequirementStageShortlistInputForm from './components/abstract/workflow/requirement_stage/shortlist/form';

import AbstractBulkNotificationSignForm from "./components/abstract/bulk/notification/sign/form";
//
// Karin Law
import KarinLawDocumentTypeForm from './components/karin_law/document_type/form';
import KarinLawWorkflowBasicForm from './components/karin_law/workflow/process/basic_form';
import KarinLawWorkflowRequirementCommentBox from './components/karin_law/workflow/requirement/comment/box';
//
// Economic Crime
import EconomicCrimeWorkflowBasicForm from './components/economic_crime/workflow/process/basic_form';
import EconomicCrimeWorkflowRequirementCommentBox from './components/economic_crime/workflow/requirement/comment/box';
//
// Common
import NpsResultModalForm from './components/nps/result/modal_form';
// import CheckListSharedProcessForm from './components/check_list/shared_process/form';
import OtpInputForm from './components/common/otp_input_form';
import WorkflowRequirementRoadMap from './components/workflow/requirement/roadmap'
import CustomFieldForm from "./components/custom_field/form"
import WorkflowProvider from './components/workflow/provider';
//
// New Portal
import PortalWorkflowRequirementCommentBox from './components/portal/workflow/requirement/comment/box';
import PortalProfileForm from './components/portal/profile/form';
import PortalCustomPinForm from './components/portal/custom_pin/form';
//
// Public
import PublicWorkflowRequirementCommentBox from './components/public/workflow/requirement/comment/box';
import PublicTutorialTourVirtualTour from "./components/public/tutorial/tour/virtual_tour";
//
// CustomerOnboardingProcess
import CustomerOnboardingProcessAcceptComercialCondictionsProducts from './components/customer_onboarding_process/accept_comercial_conditions_step/accept_products'
//
// Workflow
import WorkflowRequirementForm from './components/workflow/requirement/form'
import WorkflowRequirementStageToolbarEvent from './components/workflow/requirement_stage/toolbar_event'
import WorkflowRequirementStageForm from './components/workflow/requirement_stage/form'

//
//Compliance
import ComplianceBulkLoadActivitiesForm from "./components/compliance/bulk/load/form.jsx";
import ComplianceBulkLoadActivityTable from "./components/compliance/bulk/load/activity/table";
import ComplianceBulkLoadActivityItemTable from "./components/compliance/bulk/load/activity_item/table";
import ComplianceActivityForm from "./components/compliance/activity/form";
import ComplianceActivityTable from "./components/compliance/activity/table";
import ComplianceEvidenceTable from "./components/compliance/evidence/table";
import ComplianceActivityResourceModuleSelect from "./components/compliance/activity/resource_module_select";

// ControldocForm Document
import ControldocFormDocumentPreviewPdf from './components/controldoc_form/document/preview_pdf';

// ControldocAiChat
import ControldocAiChatInterface from './components/controldoc/ai/chat_interface';

// Versioner Document
import VersionerDocumentThreadContainer from './components/versioner/document/thread/container';

// Dashboard
import DashboardMetrics from './components/dashboard/metrics';

// Arauco
import LaboralBulkLoadAraucoDocxMergeFieldForm from './components/laboral/bulk/load/arauco/docx_merge_field/form';

ReactComponent.setup({
  HelloReact,
  AbstractBulkLoadEntityForm,
  AbstractBulkLoadDocumentForm,
  AbstractBulkRequestDocumentForm,
  AbstractCheckListProcessForm,
  LaboralBulkLoadHiringDocumentForm,
  LaboralBulkLoadEmployeeForm,
  LaboralBulkLoadHiringForm,
  CorporateBulkRequestAgreementDocumentForm,
  // DocumentForm,
  LaboralBulkRequestHiringDocumentForm,
  LaboralBulkNotificationSignForm,
  // ControldocFormTemplateForm,
  ControldocFormTemplateMappingLinkForm,
  DocumentTypeForm,
  CorporateBulkNotificationSignForm,
  LaboralBulkRequestZipDocumentForm,
  LaboralCheckListHiringProcessForm,
  CorporateCheckListAgreementProcessForm,
  LaboralBulkRequestDestroyEmployeeForm,
  LaboralBulkRequestDestroyDocumentForm,
  //
  // Laboral
  LaboralControldocFormTemplateForm,
  LaboralHiringDocumentForm,
  LaboralEmployeeDocumentForm,
  LaboralDocumentTypeForm,
  LaboralControldocFormTemplateLayoutForm,
  LaboralCheckListSharedProcessForm,
  LaboralCustomFieldOrderFormList,
  LaboralShortlistMappingConfigForm,
  LaboralBulkNotificationFillForm,
  //
  LaboralWorkflowBasicForm,
  LaboralWorkflowRequirementCommentBox,
  //
  // Corporate
  CorporateControldocFormTemplateForm,
  CorporateAgreementDocumentForm,
  CorporateControldocFormTemplateLayoutForm,
  CorporateDocumentTypeForm,
  CorporateCheckListSharedProcessForm,
  CorporateBulkRequestZipDocumentForm,
  // Abstract
  AbstractControldocFormTemplateForm,
  AbstractFaoMappingConfigForm,
  AbstractDocumentForm,
  AbstractDocumentTypeForm,
  AbstractControldocFormTemplateLayoutForm,
  AbstractCheckListSharedProcessForm,
  AbstractBulkRequestZipDocumentForm,
  AbstractEntityForm,
  AbstractCustomFieldOrderFormList,
  AbstractEntityFolderCheckListForm,
  AbstractEntityFolderCheckListSharedForm,
  AbstractEntityFolderCheckListRequirementForm,
  AbstractWorkflowBasicForm,
  AbstractWorkflowRequirementCommentBox,
  AbstractWorkflowRequirementStageShortlistInputForm,
  AbstractBulkNotificationSignForm,
  // KARIN LAW
  KarinLawDocumentTypeForm,
  KarinLawWorkflowBasicForm,
  KarinLawWorkflowRequirementCommentBox,
  //
  // Economic Crime
  EconomicCrimeWorkflowBasicForm,
  EconomicCrimeWorkflowRequirementCommentBox,
  //
  // Common
  NpsResultModalForm,
  OtpInputForm,
  WorkflowProvider,
  WorkflowRequirementRoadMap,
  CustomFieldForm,
  // New Portal
  PortalWorkflowRequirementCommentBox,
  PortalProfileForm,
  PortalCustomPinForm,
  //
  // Public
  PublicWorkflowRequirementCommentBox,
  PublicTutorialTourVirtualTour,
  //
  // CustomerOnboardingProcess
  CustomerOnboardingProcessAcceptComercialCondictionsProducts,
  //
  // Workflow
  WorkflowRequirementForm,
  WorkflowRequirementStageToolbarEvent,
  WorkflowRequirementStageForm,
  // Compliance
  ComplianceBulkLoadActivitiesForm,
  ComplianceBulkLoadActivityTable,
  ComplianceBulkLoadActivityItemTable,
  ComplianceActivityForm,
  ComplianceActivityTable,
  ComplianceEvidenceTable,
  ComplianceActivityResourceModuleSelect,
  // ControldocForm Document
  ControldocFormDocumentPreviewPdf,

  // ControldocAiChat
  ControldocAiChatInterface,

  // Versioner Document
  VersionerDocumentThreadContainer,

  // Dashboard
  DashboardMetrics,

  // Arauco
  LaboralBulkLoadAraucoDocxMergeFieldForm,
});
